<script setup lang="ts">
  import { type HTMLAttributes } from 'vue'
  import { Separator } from '../separators'
  import { cn } from '@gat-ship/vue-components'

  defineOptions({
    inheritAttrs: false
  })

  const props = defineProps<{
    title?: string
    description?: string
    class?: HTMLAttributes['class']
    /** Class for the "content" (column two) container */
    contentClass?: HTMLAttributes['class']
  }>()
</script>

<template>
  <div
    :class="
      cn(
        '@[700px]:grid-cols-2 @container @container/content-row-two-columns grid grid-cols-1 gap-6 pb-6 text-sm',
        props.class
      )
    "
  >
    <slot name="column-one">
      <div>
        <div class="font-medium">
          <slot name="title">
            {{ props.title }}
          </slot>
        </div>
        <div
          v-if="props.description || $slots.description"
          class="text-soft mt-1 text-xs"
        >
          <slot name="description">
            {{ props.description }}
          </slot>
        </div>
      </div>
    </slot>
    <div :class="cn('@container flex flex-col gap-4', props.contentClass)">
      <slot />
    </div>
  </div>
</template>
